import { SvgIcon, SvgIconProps } from '@mui/material';

const KeyPersonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.833 9.16669V14.1667"
          stroke="var(--mui-palette-text-secondary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.833 10.8333H17.4997"
          stroke="var(--mui-palette-text-secondary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66699 17.5C1.6669 16.2559 2.01497 15.0365 2.67183 13.9799C3.32869 12.9232 4.26813 12.0715 5.38387 11.521C6.49961 10.9705 7.74715 10.7432 8.98535 10.8648C10.2236 10.9864 11.403 11.4521 12.3903 12.2092"
          stroke="var(--mui-palette-text-secondary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33366 10.8333C10.6348 10.8333 12.5003 8.96785 12.5003 6.66667C12.5003 4.36548 10.6348 2.5 8.33366 2.5C6.03247 2.5 4.16699 4.36548 4.16699 6.66667C4.16699 8.96785 6.03247 10.8333 8.33366 10.8333Z"
          stroke="var(--mui-palette-text-secondary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8337 17.5C16.7541 17.5 17.5003 16.7538 17.5003 15.8334C17.5003 14.9129 16.7541 14.1667 15.8337 14.1667C14.9132 14.1667 14.167 14.9129 14.167 15.8334C14.167 16.7538 14.9132 17.5 15.8337 17.5Z"
          stroke="var(--mui-palette-text-secondary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default KeyPersonIcon;
